import { AnnouncementType } from '@office-start/announcement-component';
import { withLazyFeatureGateErrorBoundary } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
var MyContentMigrationAnnouncement = withLazyFeatureGateErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "announcement-component" */ '@office-start/announcement-component');
}), 'MyContentMigrationAnnouncement', {
    disabledFeatureGateSelector: function (featureGates) {
        var _a;
        return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.myContentGates) === null || _a === void 0 ? void 0 : _a.myContentMigrationAnnouncementEnabled);
    },
});
export var MyContentMigrationAnnouncementWrapper = function () { return (React.createElement(MyContentMigrationAnnouncement, { announcementType: AnnouncementType.MyContentMigration })); };
//# sourceMappingURL=MyContentMigrationAnnouncementWrapper.js.map